import Basic from "./Basic.jsx";
import Confirmation from "./Confirmation.jsx";
import CustomModal from "./CustomModal.jsx";

export default {
  Basic,
  Confirmation,
  CustomModal
};
